import isEmpty from 'lodash/isEmpty';

import type { TWindowWithDataLayer, TWindowWithYandexMetric } from './models';

export const hasYandexMetric = (obj: unknown): obj is TWindowWithYandexMetric =>
    !!obj && typeof (obj as TWindowWithYandexMetric).ym === 'function';

export const hasDataLayer = (obj: unknown): obj is TWindowWithDataLayer =>
    !!(obj && (obj as TWindowWithDataLayer).dataLayer);

export const isNotEmpty = <T>(obj: T): obj is NonNullable<T> => !isEmpty(obj);
